import { getAmplitudeInstance } from '../amplitudeHelpers';

type logReviewsSearchBoxClickedParams = {
  trail_id: number;
};

/**
 * Trigger when a user clicks on the search box and search becomes active
 * @param params - Attributes to log with the amplitude event
 * @param params.trail_id
 */
const logReviewsSearchBoxClicked = ({ trail_id }: logReviewsSearchBoxClickedParams, callback?: () => void) => {
  getAmplitudeInstance().logEvent('reviews search box clicked', { 'trail id': trail_id }, callback);
};

export default logReviewsSearchBoxClicked;
